import { AxiosRequestSender } from '@vue-storefront/sdk-axios-request-sender';
import { client  } from '../client';

export async function getCustomerToken(email:string, password:string): Promise<[]> {
  return new AxiosRequestSender(client)
    .setUrl('login')
    .setMethod('POST')
    .setProps([{email: email, password: password}])
    .send();
}
